import { render, staticRenderFns } from "./parent-detail.vue?vue&type=template&id=79b2eb92&scoped=true&"
import script from "./parent-detail.vue?vue&type=script&lang=js&"
export * from "./parent-detail.vue?vue&type=script&lang=js&"
import style0 from "./parent-detail.vue?vue&type=style&index=0&id=79b2eb92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2eb92",
  null
  
)

export default component.exports